"use client"

import { motion } from "framer-motion"
import { Info, Award, Shield, Users } from "lucide-react"
import "../styles/QuemSomos.css"

const QuemSomos = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 },
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="quem-somos-container"
    >
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="titulo"
      >
        Quem Somos
      </motion.h1>

      <div className="conteudo">
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.3 }} className="intro-section">
          <div className="section-icon">
            <Info size={24} />
          </div>
          <p>
            <strong>A Ticket do Vaqueiro</strong> nasceu com o propósito de modernizar e simplificar a compra e venda de
            senhas antecipadas para vaquejadas em todo o Brasil.
          </p>
          <p>
            Somos uma plataforma especializada que conecta vaqueiros com os eventos de vaquejadas, proporcionando uma
            experiência prática, segura e eficiente.
          </p>
        </motion.div>

        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.4 }} className="features-section">
          <div className="section-icon">
            <Award size={24} />
          </div>
          <p>
            Nosso sistema permite que o vaqueiro adquira sua senha antecipadamente com facilidade, podendo pagar via{" "}
            <strong>Pix, boleto ou cartão de crédito em até 12x</strong> — tudo sem complicação.
          </p>
          <p>
            Pensando no organizador, disponibilizamos um painel completo e intuitivo, onde é possível acompanhar em
            tempo real todas as informações do evento: vendas, pagamentos, relatórios e gestão de participantes,
            oferecendo total controle e comodidade.
          </p>
        </motion.div>

        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.5 }} className="role-section">
          <div className="section-icon">
            <Shield size={24} />
          </div>
          <p>
            Vale destacar que a <strong>Ticket do Vaqueiro</strong> atua exclusivamente na venda antecipada das senhas.
            Somos uma empresa terceirizada, contratada pelo organizador para administrar essas vendas antes da data do
            evento.
          </p>
          <p>
            Nossa atuação é focada no ambiente digital, e não realizamos atendimento presencial ou secretaria durante a
            vaquejada.
          </p>
        </motion.div>

        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.6 }} className="conclusion-section">
          <div className="section-icon">
            <Users size={24} />
          </div>
          <p>
            Com a <strong>Ticket do Vaqueiro</strong>, o vaqueiro garante sua participação antecipadamente e o dono do
            evento tem mais segurança e organização. Tudo pensado para impulsionar o sucesso da vaquejada.
          </p>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default QuemSomos
